module.exports = __webpack_public_path__ + "img/H-63-ER-1200-MI.498882c2.png";